var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',{staticClass:"remind"},[_c('div',{staticClass:"title"},[_c('div',{staticClass:"deco"}),_c('span',[_vm._v("任务提醒")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }